import { Breadcrumb, Select, Space, Table } from 'antd'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { UserSearchSelect } from '@/components/common/UserSearchSelect'

import { GpuState } from '../components/GpuState'
import { usePagePagination } from '../components/pagePagination'
import { providerName } from '../format'
import { useGpuProviders } from '../hooks/useGpuAdmin'
import {
  type GpuInstance,
  type InstanceFilters,
  useGpuInstances,
} from '../hooks/useGpuOperations'
import { INSTANCE_STATUSES, instanceColumns, WORKLOADS } from './columns'

const options = (values: string[]) =>
  values.map((v) => ({ label: v, value: v }))

export default function GpuInstancesListPage() {
  const navigate = useNavigate()
  const [filters, setFilters] = useState<InstanceFilters>({})
  const { query, pagination, reset } = usePagePagination()
  const { data, isFetching, error } = useGpuInstances(filters, query)
  const providers = useGpuProviders().data ?? []

  const set = (key: keyof InstanceFilters) => (value: string | undefined) => {
    setFilters((f) => ({ ...f, [key]: value }))
    reset()
  }

  return (
    <div>
      <Breadcrumb
        style={{ marginBottom: 16 }}
        items={[{ title: 'GPU' }, { title: 'Instances' }]}
      />
      <GpuState error={error} />
      <Space wrap style={{ marginBottom: 16 }}>
        <UserSearchSelect style={{ width: 250 }} onChange={set('user_id')} />
        <Select
          placeholder="Provider"
          aria-label="Provider"
          allowClear
          style={{ width: 140 }}
          onChange={set('provider')}
          options={providers.map((p) => ({
            label: providerName(p.key),
            value: p.key,
          }))}
        />
        <Select
          placeholder="Status"
          aria-label="Status"
          allowClear
          style={{ width: 140 }}
          onChange={set('status')}
          options={options(INSTANCE_STATUSES)}
        />
        <Select
          placeholder="Workload"
          aria-label="Workload"
          allowClear
          style={{ width: 140 }}
          onChange={set('workload')}
          options={options(WORKLOADS)}
        />
      </Space>
      <Table<GpuInstance>
        rowKey="id"
        dataSource={data?.items}
        columns={instanceColumns}
        loading={isFetching}
        pagination={pagination(data?.pagination)}
        size="small"
        scroll={{ x: 'max-content' }}
        locale={{ emptyText: 'No GPU instances' }}
        onRow={(instance) => ({
          style: { cursor: 'pointer' },
          onClick: () => void navigate(`/gpu/instances/${instance.id}`),
        })}
      />
    </div>
  )
}
